<template>
    <div class="tpl-content-wrapper">
        <div class="tpl-portlet-components">
            <div class="tpl-portlet-title">
                <div class="tpl-caption font-blue">
                    <i class="am-icon-dashboard"></i>
                    <span>专业路径</span>
                    <span class="desc"></span>
                </div>
                <div class="tpl-more mt-2">
                    <ul>
                        <li>
                            <router-link :to="{ name: 'path'}" tag="a">更多
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "learning_side"
    }
</script>

<style scoped>

</style>